import { useEffect, useRef, useState } from 'react';
import { LoadingStatus, LoadMoreButtonType } from './partials/LoadMoreButton';
import { focusNonFocusableElement } from '../../../lib/DomUtils/utils';
import axios from 'axios';

export function useLoadMore<T>(
  loadMore: LoadMoreButtonType | undefined,
  resultContents: T[] | undefined,
) {
  const [resultList, setResultList] = useState(resultContents);
  const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(undefined);
  const [loadMoreStatus, setLoadMoreStatus] = useState(loadMore);
  const [itemToBeFocused, setItemToBeFocused] = useState(loadMore?.fromResults);

  const listContainerRef = useRef<HTMLDivElement>(null);
  const listItemRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    // scrolling to the status (end of scroll container) when loading, so loading status is visible
    if ((loadingStatus === 'sending' || loadingStatus === 'fail') && listContainerRef?.current) {
      listContainerRef.current.scrollTop = listContainerRef.current.scrollHeight;
    }
    // resetting the loading status
    if (loadingStatus === 'success' && listItemRef?.current) {
      focusNonFocusableElement(listItemRef.current);
      setLoadingStatus(undefined);
    }
  }, [loadingStatus, resultList]);

  const loadMoreItems = () => {
    if (loadMoreStatus?.url) {
      setLoadingStatus('sending');
      axios
        .get(loadMoreStatus.url)
        .then((res) => {
          setLoadingStatus('success');
          setLoadMoreStatus(res.data.loadMore);
          setItemToBeFocused(loadMoreStatus.fromResults);
          setResultList(resultList?.concat(res.data.results));
        })
        .catch(() => {
          setLoadingStatus('fail');
        });
    } else {
      // initial state & focus on first element
      setLoadingStatus('success');
      setResultList(resultContents);
      setLoadMoreStatus(loadMore);
      setItemToBeFocused(1);
    }
  };

  return {
    resultList,
    loadingStatus,
    loadMoreStatus,
    itemToBeFocused,
    listContainerRef,
    listItemRef,
    loadMoreItems,
  };
}
